<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col><h3>■契約書の送付先</h3></v-col>
                    </v-row>
                </v-container>
                
                <v-container v-if="isPaid">
                    <v-row>
                        <v-col class="py-0">【承認者】</v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table :headers="authorizerHeaders" :items="authorizerItems" hide-default-footer fixed-header>
                                <template v-slot:body="props">
                                    <draggable
                                        :list="authorizerItems"
                                        tag="tbody"
                                        @end="replaceAuthorizerName"
                                    >
                                        <tr v-for="(item, index) in authorizerItems" :key="index" >
                                            <td class="td_move">
                                                <v-icon small class="page__grab-icon" >mdi-arrow-all</v-icon>
                                            </td>
                                            <td class="td_order">
                                                <v-avatar :size="30" color="grey lighten-4">
                                                    <span>{{ index + 1 }}</span>
                                                </v-avatar>
                                            </td>
                                            <td class="td_name"> {{ item.destination_user_name }} </td>
                                            <td class="td_email"> {{ item.destination_email_address }} </td>
                                            <td class="td_company"> {{  }} </td>
                                            <td class="td_actionBtn">
                                                <v-btn color="blue" class="white--text" @click="editAuthorizerItem(item)">編集</v-btn>
                                            </td>
                                            <td class="td_actionBtn">
                                                <v-btn color="blue-grey" class="white--text" @click="confirmAuthorizerDialog(item)">削除</v-btn>
                                            </td>
                                        </tr>
                                    </draggable>
                                </template>
                                <template v-slot:footer>
                                    <div class="mt-0 pt-2">
                                        <v-btn @click="addAuthorizerItem" color="orange" class="white--text">承認者を追加</v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-container>
                
                <v-container>
                    <v-row>
                        <v-col class="py-0">【署名者】</v-col>
                    </v-row>
                    <v-row>
                        <v-col class="py-0">
                            <v-data-table
                                :headers="headers"
                                :items="signerItems"
                                hide-default-footer
                            >
                                <template v-slot:body="props">
                                  <draggable
                                    :list="signerItems"
                                    tag="tbody"
                                    @end="replaceSignerName"
                                  >
                                    <tr
                                      v-for="(item, index) in signerItems"
                                      :key="index"
                                    >
                                      <td class="td_move">
                                        <v-icon
                                          small
                                          class="page__grab-icon"
                                        >
                                          mdi-arrow-all
                                        </v-icon>
                                      </td>
                                      <td class="td_order">
                                        <v-avatar :size="30" color="grey lighten-4">
                                            <span>{{ authorizerCount + index + 1 }}</span>
                                        </v-avatar>
                                      </td>
                                      <td class="td_name"> {{ item.destination_user_name }} </td>
                                      <td class="td_email"> {{ item.destination_email_address }} </td>
                                      <td class="td_company"> {{ item.destination_company_name }} </td>
                                      <td class="td_actionBtn">
                                        <v-btn color="blue" class="white--text" @click="editItem(item)">編集</v-btn>
                                      </td>
                                      <td class="td_actionBtn">
                                        <v-btn color="blue-grey" class="white--text" @click="confirmDialog(item)">削除</v-btn>
                                      </td>
                                    </tr>
                                  </draggable>
                                </template>
                                <template v-slot:footer>
                                    <v-row class="mt-0 pt-2">
                                        <v-col>
                                            <v-btn @click="addItem" color="orange" class="white--text">署名者を追加</v-btn>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
        <div class="text-center pt-2">
            <v-btn color="red" class="white--text" @click="next">次へ</v-btn>
        </div>

        <!-- 承認者ダイアログ -->
        <template-author-dialog-component
            v-if="authorizerDialog" 
            :authorizerDialog.sync="authorizerDialog"
            :sender="senderItem" 
            :currentAuthorizerList="authorizerItems" 
            :currentIndex="currentIndex" 
            :currentItem="currentItem" 
            @clickOk="changeAuthorizerEvent"
        >
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </template-author-dialog-component>

        <!-- 承認者 - 削除確認ダイアログ -->
        <simple-dialog-component 
            v-if="confirmAuthorizerDeleteDialog" 
            :dialog.sync="confirmAuthorizerDeleteDialog"
            :currentIndex="currentIndex"
            :currentItem="currentItem"
            @clickOk="deleteAuthorizerItem(currentItem)"
            okBtn="削除"
            cancelbtn="キャンセル"
        >
            <div>{{ currentItem.destination_user_name }}を削除しますか？</div>
        </simple-dialog-component>

        <!-- 署名者ダイアログ -->
        <template-signer-dialog-component
            v-if="signerDialog"
            :signerDialog.sync="signerDialog"
            :sender="senderItem"
            :currentSignerList="signerItems"
            :currentIndex="currentIndex"
            :currentItem="currentItem"
            @clickOk="changeEvent"
        >
            <template v-slot:ok-btn>OK</template>
            <template v-slot:cancel-btn>キャンセル</template>
        </template-signer-dialog-component>
        
        <!-- 署名者 - 削除確認ダイアログ -->
        <simple-dialog-component
            v-if="confirmDeleteDialog"
            :dialog.sync="confirmDeleteDialog"
            :currentIndex="currentIndex"
            :currentItem="currentItem"
            @clickOk="deleteItem(currentItem)"
            okBtn="削除"
            cancelbtn="キャンセル"
        >
            <div>{{ currentItem.destination_user_name }}を削除しますか？</div>
        </simple-dialog-component>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';

    export default {
        components:{
            draggable,           // ドラッグ＆ドロップ
        },
        props: {
            model: Object,
            sender: Object,
            authorizer: Array,
            signer: Array,
            isPaid: Boolean,
        },
        data() {
            return {
                senderItem:[],
                authorizerItems: [],
                authorizerDialog: false,
                confirmAuthorizerDeleteDialog: false,
                authorizerHeaders: [
                    { text: '', value: 'icon', sortable: false, width: '35' },
                    { text: '送付順', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                signerItems: [],
                signerDialog: false,
                confirmDeleteDialog: false,
                headers: [
                    { text: '', value: 'icon', sortable: false, width: '35' },
                    { text: '送付順', value: 'sn', sortable: false, width: '65' },
                    { text: '氏名', value: 'destination_user_name', sortable: false },
                    { text: 'メールアドレス', value: 'destination_email_address', sortable: false },
                    { text: '会社名', value: 'destination_company_name', sortable: false },
                    { text: '', value: 'edit', sortable: false, width: '75' },
                    { text: '', value: 'delete', sortable: false, width: '75' },
                ],
                sending: false,
                message: {
                    success: false,
                    text: '',
                },
                inportCsvData:[],
            };
        },
        computed: {
            authorizerCount: {
                get() {
                    return this.authorizerItems.length;
                },
                set() {}
            },
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
        },
        // 初期表示のデータ
        created : function() {
            this.senderItem = this.sender;
            this.authorizerItems = this.authorizer;
            this.signerItems = this.signer;
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result) {
                        window.location = "input";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            // 保存
            save: async function() {
                var self = this;
                let result = false;
                await window.axios
                    .post('address', {
                        'authorizer': this.authorizerItems,
                        'signer': this.signerItems,
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            result = true;
                        } 
                        else {
                            result = false;
                            if (response.data.message) {
                                self.message.text = response.data.message;
                            } else {
                                self.message.text = "保存処理に失敗しました";
                            }
                            self.message.success = false;
                        }
                    })
                    .catch(function (response) {
                        result = false;
                        console.log(response);
                        self.message.text = "保存処理に失敗しました";
                        self.message.success = false;
                    }
                );
                return result;
            },
            addAuthorizerItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                };
                this.authorizerDialog = true;
            },
            editAuthorizerItem: function(item) {
                this.currentIndex = this.authorizerItems.indexOf(item);
                this.currentItem = JSON.parse(JSON.stringify(item));    // クローンの意図
                this.authorizerDialog = true;
            },
            changeAuthorizerEvent: function(value) {
                if (this.currentIndex === null) {
                    this.authorizerItems.push(value);
                } else {
                    this.$set(this.authorizerItems, this.currentIndex, value);
                }
                this.replaceAuthorizerName();
                this.currentItem = value;
            },
            confirmAuthorizerDialog: function(item) {
                this.currentIndex = this.authorizerItems.indexOf(item);
                this.currentItem = item;
                this.confirmAuthorizerDeleteDialog = true;
            },
            deleteAuthorizerItem: function(item) {
                const index = this.authorizerItems.indexOf(item);
                this.authorizerItems.splice(index, 1);
                this.replaceAuthorizerName();
            },
            replaceAuthorizerName: function() {
                let regExp = new RegExp('^承認者_\\d+$');
                this.authorizerItems = this.authorizerItems.map( (authorizer, index) => {
                    if (authorizer.destination_user_name == null || authorizer.destination_user_name == "" || regExp.test(authorizer.destination_user_name)) {
                        authorizer.destination_user_name =  '承認者_' + (index + 1);
                    }
                    return authorizer;
                });
            },
            addItem: function() {
                this.currentIndex = null;
                this.currentItem = {
                    // id: '',
                    destination_user_name: '',
                    destination_email_address: '',
                    destination_company_name: '',
                };
                this.signerDialog = true;
            },
            editItem: function(item) {
                this.currentIndex = this.signerItems.indexOf(item);
                this.currentItem = JSON.parse(JSON.stringify(item));    // クローンの意図
                this.signerDialog = true;
            },
            changeEvent: function(value) {
                if (this.currentIndex === null) {
                    this.signerItems.push(value);
                } else {
                    this.$set(this.signerItems, this.currentIndex, value);
                }
                this.replaceSignerName();
                this.currentItem = value;
            },
            confirmDialog: function(item) {
                this.currentIndex = this.signerItems.indexOf(item);
                this.currentItem = item;
                this.confirmDeleteDialog = true;
            },
            deleteItem: function(item) {
                const index = this.signerItems.indexOf(item);
                this.signerItems.splice(index, 1);
                this.replaceSignerName();
            },
            replaceSignerName: function() {
                let regExp = new RegExp('^署名者_\\d+$');
                this.signerItems = this.signerItems.map( (signer, index) => {
                    if (signer.destination_user_name == null || signer.destination_user_name == "" || regExp.test(signer.destination_user_name)) {
                        signer.destination_user_name =  '署名者_' + (index + 1);
                    }
                    return signer;
                });
            },
        },
    };
</script>

<style scoped>
    /* table */
    ::v-deep th {
        padding: 5px 0!important;
        word-break: keep-all;
        white-space : nowrap;
    }
    ::v-deep td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
        padding: 5px 0!important;
    }
    .td_move {
        width: 35px;
        text-align: center;
    }
    .td_order {
        width: 69px;
        text-align: center;
    }
    .td_name {
        width: 200px;
    }
    .td_email {
        /*width: 250px;*/
        padding-right: 15px !important;
    }
    .td_company {
        
    } 
    .td_actionBtn {
        width: 75px;
        text-align: center;
    }
    ::v-deep .v-data-table__empty-wrapper {
        display: none;
    }
</style>